import { CookieModule, HttpModule, LoggerModule } from "@packages/common";
import type { Module } from "@webmotors/ioc";

import { AuthService } from "./auth.service";
import { TokenService } from "@packages/common/src/token/token.service";

export const AuthModule: Module = {
  name: "AuthModule",
  modules: [CookieModule, LoggerModule, HttpModule],
  providers: [AuthService, TokenService],
};
